<template>
  <b-modal
    id="select-layout-modal"
    title="Select Layout Images"
    size="lg"
    ok-only
    :ok-disabled="!selectedItems.length"
    @ok="handleOkClick"
    @show="getLayouts('shown')"
  >
    <div class="layouts-table">
      <div
        v-for="(layout) in layouts.items"
        :key="`layout_${layout.id}`"
        class="item-main-block position-relative"
        @click="showLayoutPreviewModal(layout)"
      >
        <div class="d-flex flex-column align-items-center p-1 layout-item">
          <div class="layout-box">
            <img
              :src="`/share?file=${layout.thumbnail}`"
              alt="layout-thumbnail"
              @error="(event) => event.target.src = '/images/image.svg'"
            >
          </div>
          <div
            class="text-center name-container"
          >
            <p>{{ getTrimFileName(layout.name) }}</p>
          </div>
        </div>
      </div>
    </div>
    <VuePagination
      :pagination.sync="layouts"
      :offset="2"
      class-name="layouts-pagination"
      @paginate="getLayouts()"
    />

    <SelectImageToAnalyseModal
      ref="layoutPreviewModal"
      @onSelectedItems="addLayoutLayersFlow"
    />
  </b-modal>
</template>
<script>
/* eslint vue/enforce-style-attribute: 0 */
import LayoutAPI from "@frontend/services/api/layout";
import VuePagination from "@frontend/components/common/PaginationComponent.vue";
import SelectImageToAnalyseModal from './SelectImagesToAnalyseModal.vue';
import {trimFileName} from "@frontend/services/helpers";

export default {
  components: {VuePagination, SelectImageToAnalyseModal},
  props: {
    mode: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      selectedItems: [],
      layouts: {
        current_page: 1,
        per_page: 12,
        last_page: 99,
        items: [],
      }
    }
  },
  mounted() {
    // this.getLayouts()
  },
  methods: {
    async handleOkClick() {
      this.$emit('onSelectedItems', {});
    },

    async getLayouts(restart = false) {
      if (restart) {
        this.layouts.current_page = 1;
        this.layouts.items = [];
      }
      const { data } = await LayoutAPI.getLayouts({
        params: {
          page: this.layouts.current_page,
          limit: this.layouts.per_page,
        }
      });
      const { layouts, totalCount } = data;

      this.layouts.items = layouts;
      this.layouts.last_page = Math.ceil(totalCount / this.layouts.per_page);
    },
    showLayoutPreviewModal(layout) {
      this.$refs.layoutPreviewModal.show(layout.id, layout.customer_id);
    },

    addLayoutLayersFlow({images, texts}) {
      this.$bvModal.hide('select-image-to-analyse-modal')
      if (!images || !images?.length) {
        images = []
      }
      this.$emit('onSelectedItems', images);
      this.selectedItems.push(...images);
    },

    getTrimFileName(filename) {
      return trimFileName(filename, 8);
    },
  }
}
</script>

<style>
.layouts-table {
  display: grid;
  grid-template-columns: repeat(auto-fill, 120px);

  .layout-item {
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    .name-container {
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;

      p {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-bottom: 0px;
      }
    }

    &.selected {
      border: 1px solid grey;
      border-radius: 10px;
      background-color: white;
    }
  }

  .layout-box {
    overflow: hidden;
    width: 110px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 100%;
      height: auto;
    }

    svg {
      width: 100%;
    }
  }
}
.layouts-pagination {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  li > a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border: none;
    background-color: transparent;
    color: #727272!important;
    font-family: 'Nunito', sans-serif;
    font-size: 14px;
    line-height: 1.357;
    font-weight: 700;
    &:hover {
      color: #fec350;
    }
  }
  li.active > a {
    background-color: #209C86;
    color: #fff!important;
  }
}
</style>
